import React from 'react';
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from 'react-table';
import 'bootstrap/dist/css/bootstrap.min.css';

function GlobalFilter({ preGlobalFilteredRows, globalFilter, setGlobalFilter }) {
  const count = preGlobalFilteredRows.length;

  return (
    <div className="mb-4">
      <input
        type="text"
        className="form-control"
        value={globalFilter || ''}
        onChange={e => setGlobalFilter(e.target.value || undefined)}
        placeholder={`Search ${count} records...`}
      />
    </div>
  );
}

const AdminTable = ({ tableHeaders = [], tableData = [] }) => {
  const [isPageSizeOpen, setIsPageSizeOpen] = React.useState(false);
  const data = React.useMemo(
    () => (tableData.length ? tableData : []),
    [tableData] 
  );

  const columns = React.useMemo(
    () => (tableHeaders.length ? tableHeaders : []),
    [tableHeaders] 
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    
    prepareRow,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setPageSize,
  } = useTable(
    { columns, data, initialState: { pageSize: 5 } },
    useGlobalFilter, // Use global filter
    useSortBy, // Use sorting
    usePagination // Use pagination
  );

  return (
    <div className="container-fluid mt-5 pl-4 pr-4">
      {/* Search Input */}
   
      <GlobalFilter
        preGlobalFilteredRows={preGlobalFilteredRows}
        globalFilter={state.globalFilter}
        setGlobalFilter={setGlobalFilter}
      />

      {/* Table */}
      <div className="table-responsive ">
        <table {...getTableProps()} className="table table-bordered table-hover table-striped">
          <thead className="thead-dark">
            {headerGroups.map((headerGroup, index) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, colIndex) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={colIndex}
                    className="text-center"
                  >
                    {column.render('Header')}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? ' 🔽'
                          : ' 🔼'
                        : ''}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, cellIndex) => (
                    <td
                      {...cell.getCellProps()}
                      key={cellIndex}
                      className="text-center"
                    >
                      {cell.render('Cell')}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="admin-table-pagination d-flex justify-content-between align-items-center mt-3">
        <div className="admin-table-pagination__buttons">
          <button
            className="btn-lg border-0 previousbtn admin-table-pagination__button"
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          >
            Previous
          </button>
          <button
            className="btn-lg border-0 nextbtn ml-2 admin-table-pagination__button"
            onClick={() => nextPage()}
            disabled={!canNextPage}
          >
            Next
          </button>
        </div>
        <span className="admin-table-pagination__status">
          Page{' '}
          <strong>
            {state.pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
        <div
          className="admin-table-pagination__select-wrap"
          onBlur={(e) => {
            if (!e.currentTarget.contains(e.relatedTarget)) {
              setIsPageSizeOpen(false);
            }
          }}
        >
          <button
            type="button"
            className="previousbtn admin-table-pagination__select admin-table-pagination__select-trigger"
            onClick={() => setIsPageSizeOpen((open) => !open)}
            aria-haspopup="listbox"
            aria-expanded={isPageSizeOpen}
          >
            <span>Show {state.pageSize}</span>
            <span className="admin-table-pagination__select-caret">&#709;</span>
          </button>
          {isPageSizeOpen && (
            <div className="admin-table-pagination__menu" role="listbox">
              {[5, 10, 20].map((pageSize) => (
                <button
                  key={pageSize}
                  type="button"
                  className={`admin-table-pagination__menu-item${state.pageSize === pageSize ? ' is-selected' : ''}`}
                  onClick={() => {
                    setPageSize(pageSize);
                    setIsPageSizeOpen(false);
                  }}
                  role="option"
                  aria-selected={state.pageSize === pageSize}
                >
                  Show {pageSize}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminTable;
